
Checkout.PayPalCheckout = function(checkout) {
	var _ppco = this;

	var $checkoutButtonsTpl = $('#paypalcheckout-buttons-wrap-tpl'),
		$placements = $('.paypalcheckout-wrap');

	var init = function() {
		listen();
		publish();
	}

	var listen = function() {
		checkout.cart.$wrap.on('loadDone loadFail', toggleBMLButton);
		$checkoutButtonsTpl.find('button').click(submit);
	}

	var publish = function() {
		_ppco.buildContent = buildContent;
		_ppco.submit = submit;
	}

	var buildContent = function() {

		$placements.each(function(i, wrap) {
			$(wrap).html(
				$checkoutButtonsTpl.clone(true).removeAttr('id')
			);
		});

		return _ppco;
	}

	var submit = function(e) {
		$('body').addClass('submit');
		var	$submitButton = $(e.target || e.srcElement).closest('.paypal-submit'),
			$buttonsWrap = $submitButton.parents('.paypalcheckout-buttons-wrap').first(),
			currentStep = checkout.session.get('step'),
			$proceedButton = checkout[currentStep].$proceed,
			session = checkout.session.get();

		session.cartItems = checkout.cart.getItemData();
		session.totals = checkout.cart.totals.values;
		session.totals.taxRate = checkout.cart.totals.taxRate;

		if (checkout.shippingServiceGroupID) { 
			session.shippingServiceGroupID = checkout.shippingServiceGroupID; 
		} else { 
			delete session.shippingServiceGroupID; 
		} 
		session.shippingServiceCode = checkout.shippingServiceCode;

		toggleLoading($buttonsWrap, $proceedButton, true);

		var submission = new Checkout.Submit(checkout, {
			'onFails' : [function() {
				toggleLoading($buttonsWrap, $proceedButton, false);
			}]
		});

		return submission.submit({
			'step'   : 'paypal',
			'action' : 'initCheckout',
			'data'   : encodeURIComponent(JSON.stringify(session))
		});

	}

	var toggleLoading = function($buttonsWrap, $proceedButton, loading) {
		var $buttons = $buttonsWrap.find('.paypal-submit');

		$buttonsWrap.hide();

		if (loading) {

			$proceedButton.hide();
			$proceedButton.siblings('.or').hide();

			$buttons.filter('.paypal-submit-loading').show();
			$buttons.not('.paypal-submit-loading').hide();

		} else {

			$proceedButton.show();
			$proceedButton.siblings('.or').show();

			$buttons.filter('.paypal-submit-loading').hide();
			$buttons.not('.paypal-submit-loading').show();

			toggleBMLButton();
		}

		$buttonsWrap.show();

	}

	var toggleBMLButton = function(){
	}

	init()
}

